<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Statistiques",
          icon: "bi bi-bar-chart-line-fill",
          route: "statistics-index",
        },
        {
          label: "Fiche journalière",
          icon: "bi bi-calendar2-check-fill",
          route: "statistics-daily-sheet",
        },
      ],
    };
  },
};
</script>
